window.addEventListener('alpine:init', () => {
  Alpine.data('mobileMenuData', () => ({
    open: false,

    toggle() {
      this.open = !this.open;
    },

    init() {
      const triggers = document.querySelectorAll('[data-trigger-mobile-menu]');
      if(!triggers?.length) return;

      triggers.forEach(trigger => {
        trigger.addEventListener('click', () => {
          this.toggle();
        })
      });
    }
  }));
});